export const onWithdrawPaymentInfoNewEdit = (values) => {

    const errors = {}

    if (required(values.profile_id)) {
        errors.profile_id = 'profile id is required'
    }
    if (required(values.type)) {
        errors.type = 'Type required'
    }
   
    return errors;

};

export const onWithdrawPaymentInfoNewCreate = (values) => {

    const errors = {}
    if (required(values.profile_id)) {
        errors.profile_id = 'profile id is required'
    }
    if (required(values.type)) {
        errors.type = 'Type required'
    }
    
    return errors;
    

};
const isEmpty = (value: any) => {
    return (typeof value === 'undefined' || value === null || value === '')
}
export const required = (value) => {
    return isEmpty(value)
}